export default "__VITE_ASSET__DBvmK7aT__"